import React from "react";
import validate from "validate.js";
import { Input } from "components/Inputs";
import { Button, Title, ErrorBlock } from "components/Shared";
import { translate } from "lib";
import { Auth } from "aws-amplify";

class VerifyEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      state: !!props.email ? "code_sent" : false,
      email: props.email
    };
  }

  requestCode() {
    const { email } = this.state;
    const errors = validate(
      { email },
      {
        email: {
          presence: true
        }
      }
    );

    if (!errors) {
      Auth.resendSignUp(email)
        .then(() => this.setState({ errors: {}, state: "code_sent" }))
        .catch(errors => this.setState({ errors: { email: [errors.message] } }));
    } else {
      this.setState({ errors });
    }
  }

  verifyEmail() {
    const { onUpdate } = this.props;
    const { email, verification } = this.state;

    const errors = validate(
      { email, verification },
      {
        email: {
          presence: true
        },
        verification: {
          presence: true
        }
      }
    );
    if (!errors) {
      Auth.confirmSignUp(email, verification)
        .then(() => (!!onUpdate ? onUpdate() : this.setState({ errors: {}, state: "email_verified" })))
        .catch(errors => {
          this.setState({ errors: { verification: errors } });
        });
    } else {
      this.setState({ errors });
    }
  }

  render() {
    const { onUpdate } = this.props;
    const { state, errors } = this.state;
    if (!onUpdate && state === "email_verified") {
      return (
        <React.Fragment>
          <Title>{translate("verify_email")}</Title>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <ErrorBlock {...{ errors }} />
        <Title>{translate("verify_email")}</Title>
        <Input
          name="email"
          disabled={!!onUpdate}
          defaultState={this.state}
          onChange={email => this.setState({ email })}
        />
        {state === "code_sent" ? (
          <React.Fragment>
            <Input
              name="verification"
              onChange={verification => this.setState({ verification })}
              defaultState={this.state}
            />
            <Button onClick={() => this.verifyEmail()}>{translate("verify")}</Button>
          </React.Fragment>
        ) : (
          <Button onClick={() => this.requestCode()}>{translate("request_code")}</Button>
        )}
      </React.Fragment>
    );
  }
}

export default VerifyEmail;
